import { h } from 'preact';
import styled from 'styled-components';

export default function Loader({ width, height, className }) {
    return <Loading width={width} height={height} className={className} />;
}

const Loading = styled.div`
    position: relative;
    width: ${props => props.width || '4rem'};
    height: ${props => props.height || '4rem'};

    &::before,
    &::after {
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: var(--secondary);
        border-radius: 50%;
        opacity: 0.7;
        animation: loading-pulse 2s infinite ease-in-out;
    }

    &::after {
        animation-delay: -1s;
    }

    @keyframes loading-pulse {
        0%,
        100% {
            transform: scale(0);
        }
        50% {
            transform: scale(1);
        }
    }
`;
